export default __webpack_public_path__ + "static/media/VIPL_Fiscal_24.ce13ea47.pdf";